module.exports = __webpack_public_path__ + "static/fonts/Fact-Bold.18fc093.woff2";